import { v4 as uuidv4 } from 'uuid';
import { JSONSchema7 } from 'json-schema';
import ControlKind from '../../../Shared/controlKind';
import { GridSize } from '../../../Shared/Enums/gridSize';

export default (controlId: string, pageExternalId: string, order: number) => {
  return {
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: `#${pageExternalId}/${controlId}`,
    type: 'object',
    properties: {
      version: {
        $id: `#${pageExternalId}/${controlId}/version`,
        default: 2,
        type: 'number'
      },
      label: {
        $id: `#${pageExternalId}/${controlId}/label`,
        type: 'string'
      },
      displayName: {
        $id: `#${pageExternalId}/${controlId}/displayName`,
        default: '',
        type: 'string'
      },
      id: {
        $id: `#${pageExternalId}/${controlId}/id`,
        default: `${uuidv4().replace(/-/g, '')}`,
        type: 'string'
      },
      externalId: {
        $id: `#${pageExternalId}/${controlId}/externalId`,
        default: '',
        type: 'string'
      },
      data: {
        $id: `#${pageExternalId}/${controlId}/data`,
        default: '',
        type: 'string'
      },
      mimeType: {
        $id: `#${pageExternalId}/${controlId}/mimeType`,
        default: '',
        type: 'string'
      },
      filename: {
        $id: `#${pageExternalId}/${controlId}/filename`,
        default: '',
        type: 'string'
      },
      type: {
        $id: `#${pageExternalId}/${controlId}/type`,
        title: 'Type',
        default: ControlKind.ATTACHMENT,
        type: 'string'
      },
      order: {
        $id: `#${pageExternalId}/${controlId}/order`,
        default: order,
        type: 'integer'
      },
      conditional: {
        $id: `#${pageExternalId}/${controlId}/conditional`,
        default: false,
        type: 'boolean'
      },
      gridSize: {
        $id: `#${pageExternalId}/${controlId}/gridSize`,
        default: GridSize.FULL,
        type: 'number'
      }
    }
  } as JSONSchema7;
};
